// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a9127632","264":"e3f3226a","289":"40cdd8d5","384":"287f787b","401":"760ab409","428":"358a6e70","434":"c4eb727a","515":"7c3f2021","568":"ddc1bfe1","823":"b33818ce","857":"954bbeee","960":"8e2f8b27","979":"9e0fd03c"}[chunkId] + ".chunk.js";
};